import { render, staticRenderFns } from "./extraSelection.vue?vue&type=template&id=1ece812f&scoped=true&"
import script from "./extraSelection.vue?vue&type=script&lang=js&"
export * from "./extraSelection.vue?vue&type=script&lang=js&"
import style0 from "./extraSelection.vue?vue&type=style&index=0&id=1ece812f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece812f",
  null
  
)

export default component.exports